import { render, staticRenderFns } from "./PortfolioFullWidthPage.vue?vue&type=template&id=c65a8c76&"
import script from "./PortfolioFullWidthPage.vue?vue&type=script&lang=js&"
export * from "./PortfolioFullWidthPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports